import { ToolWidgetType, WidgetNode } from '@/shared/components/Mosaic'
import { TOOL_WIDGETS } from '@/shared/components/Mosaic/models/widgetType'
import {
  faChartBar, faCubesStacked, faExclamationTriangle, faGlobeOceania, faMapLocationDot, faMugSaucer, faRoute
} from '@fortawesome/pro-light-svg-icons'

export const toolWidgetNodeMapping: Record<ToolWidgetType, WidgetNode> = {
  Map: {
    icon: faMapLocationDot,
    tooltip: 'Interactive map view',
    widgetType: TOOL_WIDGETS.Map,
    name: 'Map View',
    description: 'Display interactive map to visualize routes and data.',
    location: 'toolbar'
  },
  Violations: {
    icon: faExclamationTriangle,
    tooltip: 'View violations',
    widgetType: TOOL_WIDGETS.Violations,
    name: 'Violations',
    description: 'View and manage violations.',
    location: 'toolbar'
  },
  RunsheetBreaks: {
    icon: faMugSaucer,
    tooltip: 'View breaks',
    widgetType: TOOL_WIDGETS.RunsheetBreaks,
    name: 'Breaks',
    description: 'View and manage breaks.',
    location: 'toolbar'
  },
  Geocode: {
    icon: faGlobeOceania,
    tooltip: 'Geocoding utilities',
    widgetType: TOOL_WIDGETS.Geocode,
    name: 'Geocode',
    description: 'Bulk geocode utilities for addresses and coordinates',
    location: 'toolbar'
  },
  GanttChart: {
    icon: faChartBar,
    tooltip: 'View scenario/run schedule',
    widgetType: TOOL_WIDGETS.GanttChart,
    name: 'Gantt Chart',
    description: 'Visualise scenario or run schedule on a Gantt chart',
    location: 'toolbar'
  },
  A2BRoute: {
    icon: faRoute,
    tooltip: 'Calculate A to B routing',
    widgetType: TOOL_WIDGETS.A2BRoute,
    name: 'A2B Routing',
    description: 'Visualise and perform A to B routing for addresses',
    location: 'toolbar'
  },
  Solver: {
    icon: faCubesStacked,
    tooltip: 'Runs & Scenarios Solver',
    widgetType: TOOL_WIDGETS.Solver,
    description: 'Show current solver statistics',
    name: 'Solver',
    location: 'toolbar'
  },
}

export const getToolWidgetNodeFromType = (widgetType: ToolWidgetType, options?: Partial<WidgetNode>): WidgetNode => ({
  ...toolWidgetNodeMapping[widgetType],
  ...options,
})